"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepCircularProgress = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var StepCircularProgress = function (_a) {
    var progress = _a.progress, size = _a.size;
    var radius = (size - 3) / 2; // Subtracting 3 for stroke width
    var circumference = 2 * Math.PI * radius;
    var offset = circumference - (progress / 100) * circumference;
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: size, height: size, className: "position-absolute", "data-testid": "step-circular-progress" }, { children: [(0, jsx_runtime_1.jsx)("circle", { className: "step-progress-track", cx: size / 2, cy: size / 2, r: radius, fill: "none", strokeWidth: "3" }), (0, jsx_runtime_1.jsx)("circle", { className: "step-progress-percent", cx: size / 2, cy: size / 2, r: radius, fill: "none", strokeWidth: "3", strokeDasharray: circumference, strokeDashoffset: offset, transform: "rotate(-90 ".concat(size / 2, " ").concat(size / 2, ")") })] })));
};
exports.StepCircularProgress = StepCircularProgress;
